import {
  CUSTOMERS_MODULE,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_USER,
  CREATE_CUSTOMER_VALIDATED,
  CREATE_CUSTOMER_SPECIAL,
  VIEW_CUSTOMER_CATALOG,
  EDIT_CUSTOMER_INFORMATION,
} from 'utils/roles/permissions/customerPermissions';
import {
  CUSTOMERS_VIEW_CATALOG_PATH,
  CUSTOMERS_ADD_PATH,
  CUSTOMERS_DETAIL_PATH,
  CUSTOMERS_EDIT_PATH,
} from 'utils/roles/paths';
import { CREATE_NEW_CUSTOMER } from '../../../utils/roles/permissions/customerPermissions';

export function customersAuth(permissions) {
  const allowedModules = [];

  const customerModule = permissions.some((permission) =>
    permission.includes('CUSTOMER')
  );

  if (customerModule) {
    allowedModules.push(CUSTOMERS_MODULE);
  }

  return allowedModules;
}

export function customersPathsAuth(permissions) {
  const allowedPaths = [];

    allowedPaths.push(CUSTOMERS_VIEW_CATALOG_PATH);




  const CREATE_PERMISSIONS = [
    CREATE_CUSTOMER,
    CREATE_NEW_CUSTOMER,
    CREATE_CUSTOMER_USER,
    CREATE_CUSTOMER_VALIDATED,
    CREATE_CUSTOMER_SPECIAL,
  ];

    allowedPaths.push(CUSTOMERS_ADD_PATH);



    allowedPaths.push(CUSTOMERS_DETAIL_PATH);

    allowedPaths.push(CUSTOMERS_EDIT_PATH);

  return allowedPaths;
}
